const config = require('./../../config.json')

let api       = `${config.api_server}loginServer/keepalive`
let minutes   =  10000 * 1

let temp

const sendFetch = jwt => {
    fetch(api, {
        method: 'put',
        headers: new Headers({
            'Authorization': jwt
        })
    }).then(r => r.json())
    .then(json => console.log( new Date(),  json) )
}

let keepAlive = store => {
    return true
  store.subscribe((mutation, state) => {
    if(state.system.token)
    {
        clearInterval(temp)
        sendFetch(state.system.token)
        temp = setInterval( () => sendFetch(state.system.token) , minutes )
    }
    else
        clearInterval(temp)
  })
}
export default keepAlive



// WEBPACK FOOTER //
// ./src/store/keepAlive.js